export default class CABA1011RequestModel {}
